// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProfileCollectionCardList_wrapper__p7Tan"};